import type { VerticalSelectOptionType, DashboardAccount } from "@happy-doc/shared-types";
import type { Account } from "./types";

/*
* Maps a Account object to a DashboardAccount object
* @param {Account} account - The account object
* @returns {DashboardAccount | undefined}
*/
export const mapChildAccountsToDashboardAccount = (account: Account): DashboardAccount | undefined => {
    if (account?.clinic_name && account?.id) {
        return {
            id: account.id,
            name: account.clinic_name,
            isArchived: false,
            status: account.status
        };
    } else {
        return undefined;
    }
};
export const mapAccountsToVerticalSelectOptions = (accounts: DashboardAccount[], stat?: string): VerticalSelectOptionType[] => {
    return accounts.map((account) => ({
        id: account.id,
        label: account.name || "Unnamed Account",
        ...(stat && { stat }),
        selectedOption: "",
        setSelectedOption: () => { },
    }));
}